import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Hero from './components/Hero';
import Intro from './components/Intro';
import HowItWorks from './components/HowItWorks';
import FabricSpecs from './components/FabricSpecs';
import CustomSkinsGallery from './components/CustomSkinsGallery';
import BottomCTA from './components/BottomCTA';
import CertificationBanner from '@/components/feature/CertificationBanner';
import { productJsonLd } from '@/components/feature/ProductJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const jsonLd = productJsonLd({
  name: 'Custom Printed Skins — Custom Branded Tent Skins | Pop Pro Tents',
  description: 'Fully customisable printed skins for your stretch tent, featuring your brand, artwork, or design. Ideal for corporate activations, sponsorships, festivals, and brand experiences. High-quality dye-sublimation printing on durable waterproof fabric.',
  url: `${siteUrl}/products/custom-printed-skins`,
  category: 'Custom Printed Skins',
});

export default function CustomPrintedSkins() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <CertificationBanner />
        <HowItWorks />
        <FabricSpecs />
        <CustomSkinsGallery />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}